<template>
  <div :class="navbarWrapperClasses">
    <div :class="extraNavClasses">
      <div
        class="nav-menu-icon"
        @click="setIsSidebarOpen(!$store.state.isSidebarOpen)"
      >
        <BIcon icon="list" class="nav-menu-icon" />
      </div>
      <div class="nav-menu-logo">
        <img src="https://picsum.photos/150/100" />
      </div>
    </div>
    <b-navbar id="main_nav">
      <div class="page-title">
        {{ $store.getters.profile.organization.name }}
      </div>
    </b-navbar>
    <div class="icon-menu">
      <BIcon
        icon="box-arrow-right"
        v-b-tooltip.hover
        title="Logout"
        v-on:click="handleLogout"
      />
    </div>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue'
import { mapMutations } from 'vuex'

export default {
  name: 'Navbar',
  components: {
    BIcon
  },
  methods: {
    ...mapMutations(['setIsSidebarOpen']),
    handleLogout() {
      this.$store.dispatch('logout').then(res => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  computed: {
    navbarWrapperClasses() {
      return [
        'h-flex',
        'navbar-wrapper',
        this.$store.state.isSidebarOpen ? 'opened' : 'closed'
      ]
    },
    extraNavClasses() {
      return [
        'h-flex',
        'navbar-extras',
        this.$store.state.isSidebarOpen ? 'opened' : 'closed'
      ]
    }
  }
}
</script>
